const MCP_CONNECTION_BLOCK_MESSAGES = {
  connector_disabled: 'Le connecteur IA est temporairement indisponible.',
  account_inactive: 'Ce compte Teachizy n’est pas actif.',
  email_unverified: 'Vérifiez votre adresse email Teachizy pour utiliser le connecteur IA.',
  store_missing: 'Ce compte n’est rattaché à aucun espace Teachizy.',
  store_suspended: 'Votre espace Teachizy est suspendu. Le connecteur sera disponible après sa réactivation.',
  plan_required: 'Le connecteur IA n’est pas disponible avec votre forfait actuel.',
  role_required: 'Votre rôle Teachizy ne permet pas d’utiliser le connecteur IA.',
};

export function describeMcpConnectionBlock(reason) {
  return MCP_CONNECTION_BLOCK_MESSAGES[reason]
    || 'Le connecteur IA n’est pas disponible pour ce compte.';
}

export function isMcpPlanBlock(reason) {
  return !reason || reason === 'plan_required';
}
